/* Recharge purchase options: when Subscribe & save is chosen, Recharge switches the product price
   (the element it tags .recharge-inner-most-price) to the subscription price. This adds the full
   one-time price crossed out beside it, and removes it again when one-time is chosen. Recharge
   renders its widget after the page loads (and again in quick views), so widgets are picked up
   as they appear. */
(() => {
  const ready = new WeakSet();

  function sync(widget, was) {
    const scope = widget.closest('.product-single__meta') || widget.closest('.shopify-section');
    const price = scope && scope.querySelector('.recharge-inner-most-price');
    const oneTimePrice = widget.querySelector('[data-price-onetime]');
    const subscribing = widget.querySelector('.rc-option__onetime') && widget.querySelector('.rc-option__subsave.rc-option--active');

    if (price && oneTimePrice && subscribing) {
      was.textContent = oneTimePrice.textContent.trim();
      if (was.previousElementSibling !== price) price.after(was);
    } else {
      was.remove();
    }
  }

  function init(widget) {
    if (ready.has(widget)) return;
    ready.add(widget);
    const was = document.createElement('s');
    was.className = 'rc-price-was';
    const run = () => sync(widget, was);
    // Recharge toggles rc-option--active and re-renders its prices when the variant changes.
    new MutationObserver(run).observe(widget, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['class'] });
    run();
  }

  function scan(root) {
    if (root.matches && root.matches('.rc-widget')) init(root);
    if (root.querySelectorAll) root.querySelectorAll('.rc-widget').forEach(init);
  }

  scan(document);
  new MutationObserver((mutations) => {
    mutations.forEach((m) => m.addedNodes.forEach((node) => { if (node.nodeType === 1) scan(node); }));
  }).observe(document.body, { childList: true, subtree: true });
})();
